import Bind from 'lodash-decorators/bind';
import React, { FormEvent, PureComponent } from 'react';
import { connect, DispatchProp } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { AuthHeader } from '../components/auth/auth_header';
import { Logo } from '../components/auth/logo';
import { RouteLink } from '../components/navigation/route_link';
// import { UserModule } from "../redux";
import styled from '../theme';
import { requestPasswordReset } from '../api/password-reset';
import Button from "../ui_components/button/button";
import FormField from "../ui_components/form/formField";
import { ValidationPopupStateInput } from "../ui_components/validation/validationPopupInput";
import ValidationForm from "../ui_components/validation/validationForm";

// tslint:disable-next-line:no-empty-interface
export interface RequestResetPasswordProps extends RouteComponentProps {}

const SigninLink = styled(RouteLink)`
  font-size: 0.8em;
`;

type StateProps = {
  errors: {
    email: {
      active: boolean;
      message: string;
    };
  };
};

export class RequestResetPassword extends PureComponent<
  RequestResetPasswordProps & DispatchProp,
  StateProps
> {
  public constructor(props: RequestResetPasswordProps & DispatchProp) {
    super(props);

    this.state = {
      errors: {
        email: { active: false, message: '' },
      },
    };
  }

  public render(): JSX.Element {
    const { errors } = this.state;
    const { email } = errors;

    return (
      <>
        <Logo />
        <AuthHeader uiSize="1.25em" style={{margin:"0.7em 0px 1em", padding:"0px 0px 10px"}}>
          Reset Password
          <SigninLink to="/login">Back to Login</SigninLink>
        </AuthHeader>
        <ValidationForm
          uiOnSubmit={this.submit}
          uiSubmitFailedIcon
          uiReportValidityMode="firstInvalid"
          uiDimmerBlurring={false}
          uiUseSubmitFailedMessageFromError
        >
          <FormField uiRequired>
            <ValidationPopupStateInput
              id="email"
              name="email"
              tabIndex={1}
              required
              minLength={1}
              maxLength={255}
              type="email"
              placeholder="Your E-Mail"
              uiPopupPosition="bottom right"
              onChange={() => this.handleSetErrors('email', '', false)}
            />
          </FormField>

          {email && email.active && (
            <div className="reset_password_email_error">
              <span>{email.message}</span>
            </div>
          )}

          <Button uiColor="primary" type="submit" tabIndex={2}>
            Reset
          </Button>
        </ValidationForm>
      </>
    );
  }

  public handleSetErrors = (key: string, message: string, active: boolean) => {
    this.setState((prev) => {
      return {
        ...prev,
        errors: {
          ...prev.errors,
          [key]: {
            active: active,
            message: message,
          },
        },
      };
    });
  };

  @Bind()
  private async submit(e: FormEvent<HTMLFormElement>): Promise<void> {
    const {
      //  dispatch,
      history,
    } = this.props;
    // tslint:disable-next-line:no-string-literal
    const email = (e.currentTarget.elements['email'] as HTMLInputElement).value.trim();

    this.handleSetErrors('email', '', false);
    const res = await requestPasswordReset(email);

    if (res && res.error) {
      // tslint:disable-next-line:no-string-literal
      if (res.message) {
        const err_message = 'Hmm… Is there a typo? We don’t recognize this email.';
        this.handleSetErrors('email', err_message, true);

        // we can use error message from the server too, but it's a bit long?
        throw new Error(err_message);
      } else {
        const err_message = 'Unable to submit form. Please contact the support';
        this.handleSetErrors('email', err_message, true);

        throw new Error(err_message);
      }
    }

    this.handleSetErrors('email', '', false);
    history.push('/password_reset');
  }
}

export const RequestResetPasswordContainer = connect()(RequestResetPassword);
